import React from 'react'
import Link from 'gatsby-link'

const PrevLink = ({ title, route }) => <Link 
  id="prev-link" 
  title={title} 
  to={route} />

export default PrevLink